<template>
  <div class="home-values">
    <div class="container">
      <h2 class="relative-section section-title font-balo font-bold">
        <span>{{$t('app.NOs valeurs')}}</span>
        <b>{{$t('app.NOs valeurs')}}</b>
      </h2>
      <div class="values-list list-inline">
        <div class="item-inline">
          <div class="value-item text-center">
            <img src="../assets/images/value1.png" alt />
            <h3 class="font-balo font-bold">{{$t('app.confort')}}</h3>
            <p>{{$t('app.confort description')}}</p>
          </div>
        </div>
        <div class="item-inline">
          <div class="value-item text-center">
            <img src="../assets/images/value2.png" alt />
            <h3 class="font-balo font-bold">{{$t('app.sécurité')}}</h3>
            <p>{{$t('app.security description')}}</p>
          </div>
        </div>
        <div class="item-inline">
          <div class="value-item text-center">
            <img src="../assets/images/value3.png" alt />
            <h3 class="font-balo font-bold">{{$t('app.propreté')}}</h3>
            <p>{{$t('app.cleanliness description')}}</p>
          </div>
        </div>
        <div class="item-inline">
          <div class="value-item text-center">
            <img src="../assets/images/value4.png" alt />
            <h3 class="font-balo font-bold">{{$t('app.services')}}</h3>
            <p>{{$t('app.service description')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "LandingValues",
  computed: {
    ...mapState({
      landingPage: state => get(state, "app.landingPage")
    })
  }
};
</script>
